import * as actionTypes from 'constants/actionTypes';

/**
 * shows a toast, docs in designcues
 * @param  {Object} toastProps - {String} message
 *                             - {String} type, "standard" | "success" | "error"
 *                             - {Object} - {String} text
 *                                        - {Function} onClick
 */
export function showToast(toastProps) {
  return {
    type: actionTypes.SHOW_TOAST,
    payload: { toastProps },
  };
}
